/**
 * R424 — 全站三語(介面 i18n / AI 產出語系 `locale` 共用值域)。
 *
 * 與 BE `app.core.locales.SupportedLocale` 同值域(docs/137 §1;送別的值 BE 回 422)。
 * 正規化 / 送不送的判準在 `features/canvas/outputLocale.ts`。
 */
export type AppLocale = 'zh-TW' | 'en' | 'ja';

/**
 * i18n 語言碼(`en-US` / `ja-JP` / `zh-TW` / 未定義)→ 三語之一;認不得一律繁中(預設語言)。
 *
 * R426 從 `features/canvas/outputLocale.ts` 搬來:`stores/catalogStore` 抓 catalog 也要它(docs/139),
 * 而 outputLocale 本身 import catalogStore —— 留在那裡就是循環依賴。
 */
export function toAppLocale(lng: string | null | undefined): AppLocale {
  if (!lng) return 'zh-TW';
  const base = lng.toLowerCase().split('-')[0];
  if (base === 'en') return 'en';
  if (base === 'ja') return 'ja';
  return 'zh-TW';
}
